export const getUrlParam = (param: string): string | null => {
  return new URLSearchParams(window.location.search).get(param);
};

export const isUrlParamSet = (param: string): boolean => {
  const value = getUrlParam(param);
  return (
    value?.toLowerCase() === "true" ||
    value?.toLowerCase() === "multimodal" ||
    value?.toLowerCase() === "textbased"
  );
};
